import createErrorType from 'app/utils/createErrorType';

interface IArgs {
  action: unknown;
  payload: unknown;
  response: string;
}

export class SocketSendError extends createErrorType('SocketSendError') {
  public action: any;
  public payload: any;

  public constructor(args: IArgs) {
    super();

    this.action = args.action;
    this.payload = args.payload;
    this.message = args.response;
  }
}

export class SocketAbortedError extends SocketSendError {
  public name: 'SocketAbortedError';
  public constructor(args: IArgs) {
    super(args);
    this.name = 'SocketAbortedError';
  }
}

export class SocketTimeoutError extends SocketSendError {
  public name: 'SocketTimeoutError';
  public constructor(args: IArgs) {
    super(args);
    this.name = 'SocketTimeoutError';
  }
}
